<!-- 返回首页  导航 -->
<template>
<div>
    <el-page-header @back="goBack" :content="title" class="back-header">
    </el-page-header>
</div>
</template>

<script >
export default {
    name: 'pageBack',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/components/PageHeader.vue